/** hast 최소 구조 — 타입 패키지는 react-markdown 의 간접 의존이라 직접 import 하지 않음 */
type HastNode = {
  type: string;
  value?: string;
  tagName?: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
};

const BR_TAG = /^<br\s*\/?>$/i;

/**
 * rehype-raw 없이는 마크다운 안의 raw HTML 이 전부 글자로 노출됨.
 * 어드민 마크다운 내보내기가 표 셀 안 줄바꿈을 <br> 로 쓰므로 그 태그만 요소로 복원.
 * 속성 없는 void 태그 한정이라 sanitize 불필요 — 그 외 raw HTML 은 여전히 글자로 유지.
 */
const rehypeAllowBr = () => (tree: HastNode) => {
  const walk = (node: HastNode) => {
    node.children?.forEach((child, i, siblings) => {
      if (child.type === 'raw' && BR_TAG.test(child.value?.trim() ?? '')) {
        siblings[i] = {
          type: 'element',
          tagName: 'br',
          properties: {},
          children: [],
        };
        return;
      }
      walk(child);
    });
  };
  walk(tree);
};

export default rehypeAllowBr;
